<template>
  <v-list three-line class="theme-bg">
    <template v-for="(item, index) in mails">
      <v-subheader
        v-if="item.header"
        :key="item.header"
        v-text="item.header"
        class="text-color"
      ></v-subheader>
      <v-divider
        v-else-if="item.divider"
        :key="index"
        :inset="item.inset"
      ></v-divider>
      <v-list-item v-else :key="item.title">
        <v-list-item-avatar>
          <v-img :src="item.avatar"></v-img>
        </v-list-item-avatar>
        <v-list-item-content class="text-color">
          <v-list-item-title
            v-html="item.title"
            class="text-color"
          ></v-list-item-title>
          <v-list-item-subtitle
            v-html="item.subtitle"
            style="color: rgb(68 218 145) !important"
          ></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<style scoped>
.theme-bg {
  background: #10163a;
}
.text-color {
  color: #fff !important;
}
</style>

<script>
//

export default {
  name: "Mail",

  data: () => ({
    mails: [
      { header: "Today's Mail" },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
        title: "Brunch this weekend?",
        subtitle:
          "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?",
      },
      { divider: true, inset: true },
      {
        avatar: "https://cdn.vuetifyjs.com/images/lists/2.jpg",
        title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
        subtitle:
          "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend.",
      },
    ],
  }),
};
</script>
